const setupValue = (event, setUpFunc, setUpErrorFunc) => {
  let target = event.target;
  let value = target.value;
  if (value == "") {
    setUpErrorFunc(true);
  }
  setUpFunc(value);
};

export { setupValue };
